var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"login_button",class:`login_${_vm.service}`,on:{"click":function($event){$event.preventDefault();return _vm.onClick.apply(null, arguments)}}},[_c('img',{staticClass:"login_icon",attrs:{"src":`/img/${_vm.service}_icon.png`}}),_c('p',{class:_vm.loginClass},[_vm._v(_vm._s(_vm.loginText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }